import { css } from '@emotion/css';

export const surveyWideCardStyles = css`
  width: 61.6rem !important;
  max-height: 100% !important;

  > div.pb-34 {
    padding-bottom: 2rem;
  }
`;
